import React from "react"

function Page({ children, classes }) {
  return (
    <section className={classes ? `page ${classes}` : "page"}>
      {children}
    </section>
  )
}

export default Page
